<template>
  <div class="page flex-v">
    <!-- <HeaderNav :topLevel="true" /> -->
    <div class="container flex hasMenu contaiBgSet">
      <Details :homeworkId="homeworkId" v-if="homeworkId" />
      <ExamList @checkDetails="checkDetails" v-show="!homeworkId" />
    </div>
    <img
      v-if="homeworkId"
      class="backBox"
      src="https://llss-file.langsounds.com/miniapp/e5646f364e2b7f5d0359a72062aa6922.png"
      alt=""
      @click="toJump"
    />
  </div>
</template>

<script>
import ExamList from "./examList.vue";
import Details from "./details.vue";
export default {
  components: {
    ExamList,
    Details,
  },
  data() {
    return {
      isDetails: false,
      homeworkId: null,
    }
  },
  methods: {
    checkDetails(homeworkId) {
      console.log(homeworkId);
      this.homeworkId = homeworkId;
    },
    toJump() {
      this.$route.query.home ? this.$router.go(-1) : this.homeworkId = null;
    }
  },
  mounted() {
    this.homeworkId = +this.$route.query.id || '';
  },
};
</script>

<style lang="less" scoped>
.page {
  position: relative;
}
.container {
  flex-direction: column;
  align-items: center;
  // background: url("https://llss-file.langsounds.com/miniapp/0017baf90bf98ffffe41d58a1a7b3285.png")
  //   no-repeat;
  // background-size: 100% auto;
}
.backBox {
  position: absolute;
  left: 90px;
  bottom: 90px;
  // top: 141px; 
  width: 93px;
  height: 100px;
  cursor: pointer;
}
</style>
